export default {
  title: 'Verkoopoverzicht',
  description: 'Verkopen voor de geselecteerde periode — gebruik voor factuurafstemming met dit restaurant.',
  filters: {
    period: 'Periode',
  },
  presets: {
    this_month: 'Deze maand',
    last_month: 'Vorige maand',
    last_30_days: 'Laatste 30 dagen',
    this_year: 'Dit jaar',
  },
  fields: {
    orders_count: 'Bestellingen',
    net_sales: 'Netto-omzet',
    sales_tax: 'Omzetbelasting',
    gross_sales: 'Bruto-omzet',
    delivery_fee_tax: 'Bezorgkosten (belasting)',
    delivery_fee_gross: 'Bezorgkosten (bruto)',
    tips_gross: 'Fooi (bruto)',
    total: 'Totaal',
  },
  kpi: {
    before_tax: 'voor belasting',
    tips: 'geïnd voor het restaurant',
    owed_to_restaurant: 'verschuldigd aan het restaurant',
  },
  table: {
    title: 'Specificatie',
    subtitle: '{{range}} · Alle bedragen in {{currency}}',
    field: 'Veld',
    amount: 'Bedrag',
    empty: 'Geen bestellingen in de geselecteerde periode',
    footnote:
      'Netto-omzet is exclusief belasting; bruto-omzet telt dit erbij op · Totaal is na platformkosten, dus niet wat de klant betaalde · Terugbetalingen en terugboekingen worden verrekend · Bedragen in {{currency}}',
  },
  buttons: {
    export_csv: 'CSV exporteren',
    refresh: 'Vernieuwen',
    retry: 'Opnieuw proberen',
  },
  errors: {
    failed_to_load: {
      title: 'Kan het verkoopoverzicht niet laden',
      description: 'Er is iets misgegaan bij het laden van het rapport. Probeer het opnieuw.',
    },
  },
};
